import type React from 'react';

import { FormField, Heading, Label, Textarea } from '@zillow/constellation-10';

import type { Section } from '../../../models';
import { WASTE_AND_RECYCLING } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function WasteAndRecycling({ section, setSectionValues }: Props) {
  function onCollectionDayChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WASTE_AND_RECYCLING.FIELD_NAME.COLLECTION_DAY]: value,
    });
  }

  function onStorageLocationChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WASTE_AND_RECYCLING.FIELD_NAME.OUTSIDE_STORAGE_LOCATION]: value,
    });
  }

  return (
    <>
      <Heading level={3} textStyle="responsive.heading-xs" css={{ marginBottom: 'layout.tight' }}>
        Waste/recycling
      </Heading>
      <FormField
        required
        css={{ marginBottom: 'layout.tight' }}
        label={<Label>When is collection day for waste and recycling?</Label>}
        control={
          <Textarea
            value={section.getFieldValue(WASTE_AND_RECYCLING.FIELD_NAME.COLLECTION_DAY)}
            onChange={onCollectionDayChange}
          />
        }
      />
      <FormField
        required
        label={<Label>Where is the outside storage location for waste and recycling containers?</Label>}
        control={
          <Textarea
            value={section.getFieldValue(WASTE_AND_RECYCLING.FIELD_NAME.OUTSIDE_STORAGE_LOCATION)}
            onChange={onStorageLocationChange}
          />
        }
      />
    </>
  );
}

export default WasteAndRecycling;
